import React, { useState, useEffect } from 'react';
import "./BybFooter.css"
import { Link } from 'react-router-dom'
import Modal from 'react-bootstrap/Modal';
import { ABOUT_BYB_DESCRIPTION } from '../../Common/Seo/aboutBybContent';

function BybFooter() {
   // StartUp Modal
   const [modalShow, setModalShow] = React.useState(false);


  function ContactUs(props) {
    return (
      <Modal
        {...props}
        size="lg"
        backdrop="static"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="contact_us_modal "
      >
         <Modal.Header closeButton className="border-0">
        {/* <Modal.Title id="contained-modal-title-vcenter">
        Startups
        </Modal.Title> */}
      </Modal.Header>
        <Modal.Body>
        <div className="contact-container">
      <h3>Contact Us</h3>
      <div className="contact-cards">
        <div className="contact-card">
          <h2>Chat to Sales</h2>
          <p>Speak to our friendly team</p>
          <a href="mailto:info@brewyourbran">info@brewyourbrand.in</a>
        </div>
        <div className="contact-card">
          <h2>Call Us</h2>
          <p>Mon - Sat from 10am to 7pm</p>
          <p className="phone-number">+91 8150 00 22 55</p>
        </div>
      </div>
    </div>
        </Modal.Body>
      
      </Modal>
    );
  }
  useEffect(() => {
    // Ensure Typeform embed script is loaded
    const script = document.createElement('script');
    script.src = '//embed.typeform.com/next/embed.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  
     useEffect(() => {
          // Ensure Typeform embed script is loaded
          const script = document.createElement('script');
          script.src = '//embed.typeform.com/next/embed.js';
          script.async = true;
          document.body.appendChild(script);
      
          return () => {
            document.body.removeChild(script);
          };
        }, []);

  return (
    <>
     <section class='new_byb byb-footer '>
        <div class='container'>
           <div class='byb-footer-top'>
    
         
            <div class="byb-footer-logo-section new_byb_logo">
                <div class="byb-footer-logo" >
                <img src="https://brewyourbrand.blr1.cdn.digitaloceanspaces.com/logo.svg" alt="Brew Your Brand logo" />
                <p className="text-dark bottom_footer_txt byb-footer-about">{ABOUT_BYB_DESCRIPTION}</p>
                </div>
              
              <p class="byb-footer-contact"> <span>More ways to buy:</span>
                <a href="mailto:info@brewyourbrand.in"> info@brewyourbrand.in or</a> <a href="tel:+918150002255">+91-8150 00 22 55</a></p>
            </div>
         
            <div class='byb-footer-top-content'>
                <div class="byb-footer-menu">
                    <ul>
                      <li><a href="https://brewyourbrand.in/brandselfauditkit">Brand Self-Audit Kit</a></li>
                      {/* <li class='commuity_list'>
                            <div class=" brand_self front_self">
                                      <div data-tf-live="01JJV14J257ED52SCENJ77441Y" class="text-center position-relative"></div>
                                </div>
                                <button  class="blue_btn join_btn overlap_btn m-0">Join Community</button>
                                </li> */}
                      {/* <li><a href='#' class='pe-auto'>Tools</a></li>
                      <li><a href='#' class='pe-auto'>Subscribe</a></li> */}
                      <li><a href='https://chat.whatsapp.com/CTkM6q19Ltc3Btg5t6VcLZ' class=''>Join Community</a></li>

                      <li><a href='https://brewyourbrand.in/e-magazine/' class='pe-auto'>eMagazine</a></li>
                      <li><a href='https://brewyourbrand.in/quick-brand-assessment/' class='pe-auto'>Get a Quick Brand Assessment  </a></li>
                    </ul>
                </div>
            </div>
            <div class='byb-footer-top-content'>
                <div class="byb-footer-menu">
                    <ul>
                      <li><a href="https://www.linkedin.com/company/brew-your-brand">Linkedin</a></li>
                      <li><a href="https://x.com/brew_your_brand">Twitter</a></li>
                      <li><a href='https://www.facebook.com/BrewYourBrandOfficial' class='pe-auto'>Facebook</a></li>
                      <li><a href='https://www.instagram.com/brew_your_brand' class='pe-auto'>Instagram</a></li>
    
                    </ul>
                </div>
            </div>
          </div>
     
          <div class="byb-footer-line"></div>
    
          <div class="byb-footer-bottom">
            <p>Copyright © {new Date().getFullYear()} Brew Your Brand. All Rights Reserved.</p>
           
    
              <div class="byb-footer-links">
                <a href="https://brewyourbrand.in/privacy-policy">Privacy Policy</a>
                <a href="https://brewyourbrand.in/terms-and-conditions">Terms of Use</a>
             <a href="https://brewyourbrand.in/shipping-delivery">Shipping & Delivery</a>
            <a href="https://brewyourbrand.in/cancellation-refund">Cancellation & Refund Policy</a>
    
            </div>
    
         
          </div>
          </div>
    </section>
    
    <ContactUs
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
    
    </>
  )
}

export default BybFooter
